export { default } from './Carousel';
export type {
  CarouselProps,
  CarouselImage,
  CarouselHandle,
  CarouselControlsPosition,
} from './Carousel.types';
